import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { CustomHttpClientService } from 'src/app/infrastructure/services/custom-http-client.service';
import { UserProfileInputDto } from '../models/UserProfileInputDto';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: CustomHttpClientService) {}

  async GetProfileDetailsAsync() {
    return lastValueFrom(
      this.http.get(`api/profile/details`).pipe(map((data: any) => data)),
    );
  }

  async UpdateProfileDetailsAsync(userProfileInput: UserProfileInputDto) {
    return lastValueFrom(
      this.http
        .put(`api/profile/details/save`, userProfileInput)
        .pipe(map((data: any) => data)),
    );
  }

  UpdateTermsOfUseAccepted() {
    return lastValueFrom(this.http.post('api/profile/accept-terms', {}, false));
  }
}
